import http from './http';
// 设备列表
export const getList = (params, config = {}) => http.get('/riskcontrol/device/list', { params, ...config });
// 当前列表
export const getcurrentList = (params, config = {}) => http.get('/riskcontrol/device/nowbind', { params, ...config });
// 获取历史列表
export const getHistoryList = (params, config = {}) => http.get('/riskcontrol/device/bindrecord', { params, ...config });
